
export default class TextDecoder {
  static formatText = (text: any, separator?: string) => {
    if (!text) return '';
    const toReplace = separator ? separator : '\n';
    const reg = new RegExp(toReplace, "g");
    return text.split(reg).map((match: string, index: number) => (<span key={index}>{match}<br /></span>))
  }
}